import * as React from 'react';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import FormField from '@cloudscape-design/components/form-field';
import Input from '@cloudscape-design/components/input';

export interface ConfirmDeleteWithInputModalProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  confirmationText: string; // the exact string the user must type
  deleteMessage: React.ReactNode;
}

export const ConfirmDeleteWithInputModal: React.FC<ConfirmDeleteWithInputModalProps> = ({
  onConfirm,
  onCancel,
  confirmationText,
  deleteMessage,
}) => {
  const [inputValue, setInputValue] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };

  return (
    <Modal
      visible={true}
      onDismiss={onCancel}
      footer={
        <Box float='right'>
          <SpaceBetween direction='horizontal' size='xs'>
            <Button variant='link' onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={handleConfirm}
              loading={isLoading}
              disabled={inputValue !== confirmationText}
            >
              Delete
            </Button>
          </SpaceBetween>
        </Box>
      }
      header='This action cannot be undone'
    >
      <SpaceBetween size='m'>
        <div>{deleteMessage}</div>
        <FormField label={<>To confirm, type <strong>{confirmationText}</strong> below</>}>
          <Input
            value={inputValue}
            onChange={({ detail }) => setInputValue(detail.value)}
            placeholder={confirmationText}
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  );
};
